import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { commonTexts, type TireHotelAtOtherDepartmentDialogTexts } from 'noddi-util';

type Props = {
  open: boolean;
  departmentName: string;
  canSwitch: boolean;
  onSwitch: () => void;
  onContinueHere: () => void;
  translations?: TireHotelAtOtherDepartmentDialogTexts;
};

export const TireHotelAtOtherDepartmentDialog = ({
  open,
  departmentName,
  canSwitch,
  onSwitch,
  onContinueHere,
  translations
}: Props) => {
  const texts = translations ?? commonTexts.tireHotelAtOtherDepartmentDialog;

  return (
    <NoddiDialog
      open={open}
      onClose={onContinueHere}
      title={texts.title}
      description={texts.description(departmentName)}
      footer={
        <div className='flex justify-end gap-2'>
          <NoddiButton variant='outline' onClick={onContinueHere}>
            {texts.continueHere}
          </NoddiButton>
          {canSwitch && <NoddiButton onClick={onSwitch}>{texts.switchTo(departmentName)}</NoddiButton>}
        </div>
      }
    />
  );
};
